import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { Reveal, Eyebrow, EASE } from "./Reveal";
import { BuyButton } from "./BuyButton";
import { SecureCheckout } from "./PaymentBadges";

const INCLUDED = [
  "Complete traffic exchange software",
  "Free installation & setup",
  "Free domain name included",
  "Lifetime web hosting included",
  "Full admin control panel",
  "Modern, responsive member area",
  "Set your own credit rates & packages",
  "24/7 live phone & ticket support",
];

const Burst = () => (
  <svg viewBox="0 0 200 200" className="animate-spin-slow absolute left-1/2 top-1/2 h-[112%] w-[112%] -translate-x-1/2 -translate-y-1/2 [animation-duration:40s]" aria-hidden="true">
    <polygon fill="#FACC15" points={Array.from({ length: 32 }, (_, i) => { const r = i % 2 ? 78 : 98; const a = (i / 32) * Math.PI * 2; return `${100 + r * Math.cos(a)},${100 + r * Math.sin(a)}`; }).join(" ")} />
  </svg>
);

export const Pricing = ({ s }) => (
  <section id="pricing" className="relative overflow-hidden py-28 lg:py-36" data-testid="pricing-section">
    <div className="absolute left-1/2 top-1/2 h-[700px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-blue-600/20 blur-[140px]" />
    <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="text-center"><Eyebrow className="justify-center">Pricing</Eyebrow><h2 className="font-display mt-6 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">One price. <span className="text-gradient">Yours forever.</span></h2></Reveal>
      <Reveal delay={0.1}>
        <div className="mt-16 grid overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-[0_40px_100px_-40px_rgba(37,99,235,0.45)] lg:grid-cols-2" data-testid="pricing-card">
          <div className="relative flex flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-blue-700 to-blue-950 px-6 py-20">
            <div className="grid-lines absolute inset-0" />
            <div className="relative h-56 w-56 sm:h-72 sm:w-72">
              <Burst />
              <motion.div initial={{ scale: 0.6, rotate: -12, opacity: 0 }} whileInView={{ scale: 1, rotate: -6, opacity: 1 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 1, ease: EASE }} className="absolute inset-0 flex flex-col items-center justify-center text-[#070B14]">
                <span className="font-display text-lg font-black uppercase sm:text-xl">Only</span>
                <span className="font-display text-7xl font-black leading-none sm:text-8xl" data-testid="pricing-price">${s.price}</span>
              </motion.div>
            </div>
            <p className="font-display relative z-10 mt-12 text-center text-2xl font-black uppercase italic text-white sm:text-3xl" data-testid="pricing-label">{s.price_label}</p>
            <p className="font-mono-x relative z-10 mt-2 text-sm font-bold uppercase tracking-widest text-[#FACC15]">{s.price_note}</p>
          </div>
          <div className="p-8 sm:p-12">
            <h3 className="font-display text-xl font-bold text-slate-900 sm:text-2xl">Everything included</h3>
            <ul className="mt-8 grid gap-4 sm:grid-cols-2">
              {INCLUDED.map((f) => (<li key={f} className="flex items-start gap-3 text-slate-700"><CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-blue-600" />{f}</li>))}
            </ul>
            <BuyButton s={s} testId="pricing-buy-button" className="mt-10 w-full" />
            <SecureCheckout className="mt-5" />
            <p className="mt-4 text-center text-sm text-slate-600">Questions first? <a href="#support" className="font-semibold text-blue-600 underline-offset-4 hover:underline" data-testid="pricing-support-link">Talk to a real person.</a></p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
